import { IHttp, IHttpWrap } from '../http/types'
import { BaseApi } from './baseApi'

export class SuperAgentApi extends BaseApi {
  constructor(http: IHttp, baseUrl: string) {
    super(http, baseUrl)
  }

  async getConfig<T = unknown>(key: string): Promise<IHttpWrap<T>> {
    return this.http({
      method: 'GET',
      url: this.getUrl('core-eurekals-api/eurekals_agent/1.0/common/common-config'),
      params: { key },
    })
  }

  async createConversation(query: string): Promise<IHttpWrap<{ session_id?: string; error_code?: number }>> {
    return this.http({
      method: 'POST',
      url: this.getUrl('api/eureka/query/conversational'),
      data: { query },
    })
  }
}
